var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    clipPath: "url(#clip0_820_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24231 12L7.62106 12.6212C7.05691 13.1763 6.29628 13.4859 5.50487 13.4827C4.71346 13.4794 3.95539 13.1636 3.39577 12.604C2.83615 12.0444 2.52034 11.2863 2.51711 10.4949C2.51389 9.7035 2.82352 8.94288 3.37856 8.37872L4.88544 6.87497C5.42595 6.33337 6.15299 6.01876 6.91781 5.99553C7.68263 5.97229 8.42742 6.24218 8.99981 6.74997",
    stroke: "#4A7A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.7575 4.00006L8.37875 3.37881C8.94291 2.82377 9.70353 2.51414 10.4949 2.51736C11.2864 2.52058 12.0444 2.8364 12.604 3.39601C13.1637 3.95563 13.4795 4.71371 13.4827 5.50512C13.4859 6.29653 13.1763 7.05715 12.6213 7.62131L11.1144 9.12818C10.5735 9.66935 9.8462 9.98339 9.08139 10.006C8.31657 10.0287 7.572 9.75826 7 9.25006",
    stroke: "#4A7A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_3792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.11a6519a41807f1d5138ad23a03e4ef7.svg";
export { ForwardRef as ReactComponent };